import React from 'react'
import { useParams } from 'react-router-dom'
import Colors from 'colors.json'

import Input from 'components/Input'
import Button from 'components/Button'
import Dropdown from 'components/Dropdown'
import { Form, Formik } from 'formik'
import MerchantLookupTx from 'views/MemberProfile/ManualTx/MerchantLookupTx'
import { specialIcashRefundTxSchemas } from 'schemas/specialIcashRefundTxSchemas'
import { useSpecialIcashRefundTx } from './useSpecialIcashRefundTx'
import { useMemberTXReasons } from './useMemberTXReasons'

const FormView: React.FC<{ onCloseModal: () => void }> = ({
  onCloseModal,
}): React.ReactElement => {
  const { traderId } = useParams()
  const { membersTXReasonsOptions } = useMemberTXReasons()
  const { initialValues, handleSubmitSpecialIcashRefundTx } =
    useSpecialIcashRefundTx(onCloseModal)

  return (
    <Formik
      initialValues={initialValues}
      validationSchema={specialIcashRefundTxSchemas}
      onSubmit={handleSubmitSpecialIcashRefundTx}
    >
      {({ isSubmitting, setFieldValue }) => (
        <Form className="flex flex-col">
          <div className="mb-4">
            <MerchantLookupTx
              isMerchantLookupToggle={true}
              setFieldValue={setFieldValue}
            />
            <div className="grid grid-cols-2 gap-y-0 gap-x-4">
              <Input name="ident" label="Card Ident" containerClassName="w-full" />
              <Input
                name="externalTransactionId"
                label="External Trans ID"
                containerClassName="w-full"
              />
            </div>
            <Input name="creditValue" label="Credit Value" required containerClassName="w-full" />
            <Dropdown
              title="Transaction Reason"
              options={membersTXReasonsOptions}
              className="w-full tracking-wider mb-4"
              borderColor="#C4C4C4"
              onSelect={(data) => setFieldValue('reasonId', String(data.value))}
            />
            <Input name="traceNumber" label="Trace No." containerClassName="w-full" />
            <Input name="comments" label="Comment" containerClassName="w-full" />
          </div>
          <footer className="flex justify-end pb-4 pl-4 pr-4">
            <Button type="submit" className="mr-2 rounded bg-primary" disabled={isSubmitting}>
              <span className="tracking-wider font-bold">Submit</span>
            </Button>
            <Button
              className="bg-white border rounded border-primary"
              onClick={onCloseModal}
              style={{ color: Colors.primary }}
            >
              <span className="tracking-wider font-bold">Cancel</span>
            </Button>
          </footer>
        </Form>
      )}
    </Formik>
  )
}

export default FormView